const projectTypes = [
    'bones',
    'finishing',
    'key_delivery',
]

export default projectTypes;